import nuskin from './namespace.js';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace nuskin.site.Preferences
 */
nuskin.site.Preferences = function(preferences){
    "use strict";

    if (preferences && preferences !== null){
        this.currentPage = preferences.currentPage;
        this.startPage = preferences.startPage;
        this.countryCode = preferences.countryCode;
        this.ribbonOpen = preferences.ribbonOpen;
    }

    this.toJSON = function(){
        let preferences = {};
        preferences.currentPage = this.currentPage;
        preferences.startPage = this.startPage;
        preferences.countryCode = this.countryCode;
        preferences.ribbonOpen = this.ribbonOpen;

        return preferences;
    };

    // ---------------------------------------------
    //
    //        Define all setter methods.
    //
    // ---------------------------------------------
    this.setCurrentPage = function(currentPage){
        this.currentPage = currentPage;
    };
    this.setStartPage = function(startPage){
        this.startPage = startPage;
    };
    this.setCountryCode = function(countryCode){
        this.countryCode = countryCode;
    };
    this.setRibbonOpen = function(ribbonOpen){
        this.ribbonOpen = ribbonOpen;
    };

    // ---------------------------------------------
    //
    //        Define all getter methods.
    //
    // ---------------------------------------------
    this.getCurrentPage = function(){
        return this.currentPage;
    };
    this.getStartPage = function(){
        return this.startPage;
    };
    this.getCountryCode = function(){
        return this.countryCode;
    };
    this.getRibbonOpen = function(){
        return this.ribbonOpen;
    };
};

export default nuskin.site.Preferences;
